/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var ErrorMessagesTranslations = /** @class */ (function () {
        function ErrorMessagesTranslations() {
        }
        ErrorMessagesTranslations.config = function ($translateProvider) {
            var _a;
            var keys = ap.Constants.translationKeys.errorMessages;
            var englishTable = (_a = {},
                _a[keys.internalServerError] = 'An unexpected server error has occured and the request being made failed to complete.  Please try again or contact AutoPoint support for assistance.',
                _a);
            $translateProvider.translations('en', englishTable);
        };
        return ErrorMessagesTranslations;
    }());
    angular.module('app')
        .config(['$translateProvider', ErrorMessagesTranslations.config]);
})(app || (app = {}));
